import { Anchor } from "@omni/ui/components/Anchor/anchor.component";
import { cn } from "@omni/utils/styles";

import { FlyoutCategory } from "@/redux/modules/value/flyoutCategories/flyoutCategories.types";
import { getTagIdFor } from "@/utils/tagging/tag.utils";

type Props = {
    category: FlyoutCategory;
    className?: string;
};

export const CategoryAnchor = ({ category, className }: Props) => {
    return (
        <Anchor
            color={"link"}
            href={category.url}
            fullWidth={true}
            className={cn(
                "tw:py-2 tw:px-4 tw:text-left tw:border-b tw:border-grey-light tw:rounded-none!",
                className
            )}
            {...getTagIdFor("flyout-menu-mobile-category-link", category.code)}
        >
            {category.title}
        </Anchor>
    );
};
